import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { OrderProperty } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PurchaseContractPropertyService extends TmsWebBaseEditCreateService<OrderProperty, OrderProperty> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('PurchaseContractProperty', $localize`Purchase Contract Property`, httpService, notificationService);
  }
}
